export default "__VITE_ASSET__CVq77gO3__"